import { lazyWithRetry } from "@/react/lazyWithRetry";
import type { ClientActionDescriptor } from "@/managers/ClientActionRegistry";

// agent.automation.wizard — the AI Automation home + 4-step creation wizard.
// Bound to the ir.action row `agent.action_automation_wizard`
// (action_type="client", client_component="agent.automation.wizard").
const AutomationWizardPage = lazyWithRetry(
    () => import("../components/AutomationWizardPage").then((m) => ({ default: m.AutomationWizardPage })),
    "agent.automation.wizard",
);

const plugin: ClientActionDescriptor = {
    key: "agent.automation.wizard",
    component: AutomationWizardPage,
    paramSchema: "any",
};

export default plugin;
